import React from 'react';

const SupportMenuItemIcon = ({
  width = '15',
  height = '15',
  stroke = '#222222',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 15 15"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_3643_1462)">
      <path
        d="M3.06836 3.06787L5.45484 5.45436"
        stroke={stroke}
        strokeWidth="1.5"
      />
      <path
        d="M11.9314 3.06787L9.54492 5.45436"
        stroke={stroke}
        strokeWidth="1.5"
      />
      <path
        d="M4.79883 7.50029C4.79883 8.21638 5.08329 8.90313 5.58964 9.40948C6.09599 9.91583 6.78274 10.2003 7.49883 10.2003C8.21491 10.2003 8.90167 9.91583 9.40802 9.40948C9.91436 8.90313 10.1988 8.21638 10.1988 7.50029C10.1988 6.78421 9.91436 6.09745 9.40802 5.5911C8.90167 5.08476 8.21491 4.80029 7.49883 4.80029C6.78274 4.80029 6.09599 5.08476 5.58964 5.5911C5.08329 6.09745 4.79883 6.78421 4.79883 7.50029Z"
        stroke={stroke}
        strokeWidth="1.5"
      />
      <path
        d="M3.06836 11.9319L5.45484 9.54541"
        stroke={stroke}
        strokeWidth="1.5"
      />
      <path
        d="M11.9314 11.9319L9.54492 9.54541"
        stroke={stroke}
        strokeWidth="1.5"
      />
      <path
        d="M1.42383 7.4998C1.42383 8.29759 1.58096 9.08755 1.88626 9.82461C2.19156 10.5617 2.63904 11.2314 3.20315 11.7955C3.76727 12.3596 4.43697 12.8071 5.17403 13.1124C5.91108 13.4177 6.70105 13.5748 7.49883 13.5748C8.29661 13.5748 9.08658 13.4177 9.82363 13.1124C10.5607 12.8071 11.2304 12.3596 11.7945 11.7955C12.3586 11.2314 12.8061 10.5617 13.1114 9.82461C13.4167 9.08755 13.5738 8.29759 13.5738 7.4998C13.5738 6.70202 13.4167 5.91206 13.1114 5.175C12.8061 4.43795 12.3586 3.76825 11.7945 3.20413C11.2304 2.64002 10.5607 2.19253 9.82363 1.88724C9.08658 1.58194 8.29661 1.4248 7.49883 1.4248C6.70105 1.4248 5.91108 1.58194 5.17403 1.88724C4.43697 2.19253 3.76727 2.64002 3.20315 3.20413C2.63904 3.76825 2.19156 4.43795 1.88626 5.175C1.58096 5.91206 1.42383 6.70202 1.42383 7.4998Z"
        stroke={stroke}
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_3643_1462">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SupportMenuItemIcon;
